import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as dateFns from "date-fns";
import {
  checkSingleAppointment,
} from "../../services/helpers";

const TimeSlotMenu = (props) => {
  const {
    toggleSettings,
    toggleDeleteTimeslotModal,
    toggleDeleteAppointmentModal,
    toggleBookAppointmentModal,
    toggleBookingCancelModal,
    selectedTimeslot,
    recurrenceRule,
    isDayPage,
    setIsDayPage,
    isClickedFromCell,
    setIsSlotClickFromCell
  } = props;
  setIsDayPage(isDayPage ?? false);
  setIsSlotClickFromCell(isClickedFromCell ?? false);
  const { t } = useTranslation();

  const [isLastAppointment, setIsLastAppointment] = useState(!recurrenceRule);
  const [isSingleAppointment, setIsSingleAppointment] = useState(
    checkSingleAppointment(selectedTimeslot),
  );

  const currentAppointments =
    selectedTimeslot?.appointments
      ?.filter((item) => item.status === "pending")
      .map((item) => ({
        label: `${dateFns.format(new Date(item.startDate), "HH:mm")} - ${dateFns.format(new Date(item.endDate), "HH:mm")}`,
        value: String(item.startDate),
      })) || [];

  const isAppointmentDeletable = currentAppointments.length > 0 && !isClickedFromCell;

  useEffect(() => {
    setIsLastAppointment(!recurrenceRule);
    setIsSingleAppointment(checkSingleAppointment(selectedTimeslot));
  }, [selectedTimeslot, recurrenceRule]);

  if (isDayPage) {
    return (
      <>
        <ul className="menu-list">
          <li className="menu-item">
            <div
              className={`menu-link ${
                !isAppointmentDeletable
                  ? "disabled"
                  : isLastAppointment && isSingleAppointment && ""
              }`}
              onClick={
                isLastAppointment && isSingleAppointment
                  ? toggleDeleteTimeslotModal
                  : toggleDeleteAppointmentModal
              }
            >
              {t("configuration.deleteAppointment")}
            </div>
          </li>
          <li className="menu-item">
            <div
              className={`menu-link ${selectedTimeslot?.appointments.find((app) => app.status === "pending") || isClickedFromCell ? "red" :  "disabled"}`}
              onClick={toggleBookAppointmentModal}
            >
              {t("configuration.bookAppointment")}
            </div>
          </li>
        </ul>
      </>
    );
  }

  return (
    <>
      <ul className="menu-list">
        <li className="menu-item">
          <div className="menu-link" onClick={toggleSettings}>
            {t("configuration.editTimeslot")}
          </div>
        </li>
        <li className="menu-item">
          <div
            className={`menu-link ${
              !isAppointmentDeletable
                ? "disabled"
                : isLastAppointment && isSingleAppointment && ""
            }`}
            onClick={
              isLastAppointment && isSingleAppointment
                ? toggleDeleteTimeslotModal
                : toggleDeleteAppointmentModal
            }
          >
            {t("configuration.deleteAppointment")}
          </div>
        </li>
        <li className="menu-item">
          <div
            className={`menu-link ${isLastAppointment && isSingleAppointment && "disabled"}`}
            onClick={toggleDeleteTimeslotModal}
          >
            {t("configuration.deleteTimeslot")}
          </div>
        </li>
        <li className="menu-item">
          <div
            className={`menu-link ${selectedTimeslot?.appointments.find((app) => app.status === "pending") ? "red" : "disabled"}`}
            onClick={toggleBookAppointmentModal}
          >
            {t("configuration.bookAppointment")}
          </div>
        </li>
        <li className="menu-item">
          <div
            className={`menu-link ${selectedTimeslot?.appointments.find((app) => app.status === "confirmed") ? "red" : "disabled"}`}
            onClick={toggleBookingCancelModal}
          >
            {t("configuration.cancelBooking")}
          </div>
        </li>
      </ul>
    </>
  );
};

export default TimeSlotMenu;
